import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import { useNavigate } from 'react-router-dom';
import UserServices from '../services/UserServices';
import UserUpdate from './Update Model/UpdateUser';
import ViewUsersubcription from './View Model/ViewUsersubcription';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
Modal.setAppElement('#root');

function SubcriptionUserManager() {
  const { data, error, isLoading, run } = useAsync(UserServices.getSubcriptionUsers);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(data?.data || []);

  // Add this useEffect to update filtered data when data changes
  useEffect(() => {
    if (data?.data) {
      setFilteredData(data.data);
    }
  }, [data]);

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const filteredUsers = (filteredData || []).filter((subscription) => {
    const user = subscription.user || {};
    const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.toLowerCase();
    const email = user?.email ? user.email.toLowerCase() : '';
    const mobileNo = user?.mobileNo ? user.mobileNo.toString() : '';

    const matchesUserType = userTypeFilter
      ? user.deviceType && user.deviceType.toLowerCase() === userTypeFilter.toLowerCase()
      : true;

    const matchesPlan =
      planFilter === 'hasPlan'
        ? !!subscription?.plan?.planName
        : planFilter === 'noPlan'
          ? !subscription?.plan?.planName
          : true;

    return (
      (fullName.includes(searchQuery.toLowerCase()) ||
        email.includes(searchQuery.toLowerCase()) ||
        mobileNo.includes(searchQuery)) &&
      matchesUserType &&
      matchesPlan
    );
  });

  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const generateExcel = () => {
    const filteredData = filteredUsers?.map((subscription, index) => {
      const user = subscription.user || {};
      return {
        SNo: index + 1,
        UserType: user?.deviceType,
        Name: `${user?.firstName || ''} ${user?.lastName || ''}`,
        Plan: subscription?.plan?.planName,
        OrderNumber: user?.orderId,
        MobileNo: user?.mobileNo,
        Email: user?.email,
        State: user?.state,
        City: user?.city,
        Building: user?.building,
        AddressType: user?.apartment,
        Floor: user?.floor,
        Street: user?.street,
        Address: user?.address,
        CompletedBookings: subscription?.completedBookingsCount || 0, // Add completed bookings count
        SubscriptionDate: formatDate(subscription?.createdAt),
        Status: subscription?.status,
      };
    });

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Users');
    XLSX.writeFile(wb, 'user_subscription_data.xlsx');
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handleUserTypeChange = (e) => {
    setUserTypeFilter(e.target.value);
  };

  const handlePlanChange = (e) => {
    setPlanFilter(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">
            Active User Subscription
            <span className="badge bg-warning ms-2">
              Total: {filteredUsers.length}
            </span>
          </h5>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                User List
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center">
          <div className="pe-1 mb-xl-0">
            <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
              <button className="excel-btn" onClick={generateExcel}>
                <img src="img/excel.svg" alt="Download Excel" />
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-box px-0 user-manager">
        <div className="Tablesearch_design">
          <div className="row">
            <div className="col-sm-6">
              <div className='d-flex align-items-center justify-content-between gap-2'>
                <div className=' w-100'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by Name, Mobile and Email id"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className='form-control'
                  />
                </div>
                <div>
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
            <div className="col-sm-3 col-6">
              <div className="input-field">
                <select className="form-select selectcustum" value={userTypeFilter} onChange={handleUserTypeChange}>
                  <option value="">User Type</option>
                  <option value="Android">Android</option>
                  <option value="iOS">iOS</option>
                </select>
              </div>
            </div>
            <div className="col-sm-3 col-6">
              <div className="input-field">
                <select className="form-select selectcustum" value={planFilter} onChange={handlePlanChange}>
                  <option value="">Filter</option>
                  <option value="hasPlan">Plan Holder</option>
                  <option value="noPlan">No Plan</option>
                </select>
              </div>
            </div>
          </div>
        </div>


        <div className="row mb-3">
          <div className="col-md-12">
            <div className="card summary-card">
              <div className="card-body">
                <h6 className="card-title mb-3 fw-semibold">Summary</h6>

                <div className="row g-3">
                  <div className="col-md-3 col-sm-6">
                    <div className="summary-box">
                      <span className="summary-label">Total Active Subscriptions</span>
                      <span className="summary-value">{filteredUsers.length}</span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6">
                    <div className="summary-box">
                      <span className="summary-label">Total Completed Bookings</span>
                      <span className="summary-value">
                        {filteredUsers.reduce(
                          (total, sub) => total + (sub.completedBookingsCount || 0),
                          0
                        )}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div className="container-box-inner table-reponsive-tabe">
          <table id="example" className="table table-striped" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>#</th>
                <th>USER TYPE</th>
                <th>IMAGE</th>
                <th>NAME</th>
                <th>MOBILE NO.</th>
                <th>ADDRESS</th>
                <th>REGISTRATION DATE</th>
                <th>PLAN</th>
                <th>COMPLETED BOOKINGS</th> {/* New column */}
                <th>ORDER NUMBER</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {currentUsers?.map((subscription, index) => {
                const user = subscription.user || {};
                return (
                  <tr key={subscription?._id || index}>
                    <td>{index + 1 + indexOfFirstUser}</td>
                    <td>
                      <span className="usertype">{user?.deviceType || "N/A"}</span>
                    </td>
                    <td>
                      <img
                        src={user?.image ? `${process.env.REACT_APP_URL}${user?.image}` : 'img/profile-img.png'}
                        alt=""
                        style={{ height: '50px', width: '50px', objectFit: 'contain' }}
                      />
                    </td>
                    <td style={{ maxWidth: '100px', wordWrap: 'break-word' }}>
                      {`${user?.firstName || "N/A"} ${user?.lastName || ""}`.trim() || "N/A"}
                    </td>
                    <td>{user?.mobileNo || "N/A"}</td>
                    <td>{user?.address || "N/A"}</td>
                    <td>{subscription?.createdAt ? formatDate(subscription.createdAt) : "N/A"}</td>
                    <td>
                      <span className="badge bg-info">
                        {subscription?.plan?.planName || "N/A"}
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-success" style={{ fontSize: '14px', padding: '5px 10px' }}>
                        {subscription?.completedBookingsCount || 0}
                      </span>
                    </td>
                    <td>
                      <button
                        onClick={() => navigate(`/order?userId=${user?._id}`)}
                        style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer' }}
                      >
                        {user?.TotalOrder || "N/A"}
                      </button>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleViewDetails(subscription)}
                        data-tooltip-content="View Details"
                        data-tooltip-id="view-tooltip"
                      >
                        <FaRegEye />
                      </button>
                      <Tooltip id="view-tooltip" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredUsers?.length || 0) / usersPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Subscription Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewUsersubcription
          user={selectedUser}
          closeModal={closeModal}
        />
      </Modal>


      <style jsx>{`
  .summary-card {
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
  }

  .summary-box {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .summary-label {
    font-size: 13px;
    color: #6b7280;
    font-weight: 500;
    margin-bottom: 6px;
  }

  .summary-value {
    font-size: 24px;
    font-weight: 700;
    color: #111827;
  }
`}</style>

    </div>
  );
}

export default SubcriptionUserManager;